import styled from 'styled-components'

export const LoanCalcultaorTitleContainer = styled.div`
  width: 100%;
  height: 24px;
  margin: 44px 169px 24px 0px;
  font-family: Roboto;
  font-size: 22px;
  font-weight: bold;
  text-align: center;
  color:#000000;
`